import { colors } from "@hubrise/react-components"
import styled from "styled-components"

import { BaseCell } from "../shared/BaseCell"

export const StyledCell = styled(BaseCell)`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  accent-color: ${colors.backgroundWhite};
`
